import { create } from 'zustand'

interface User {
  id: string
  email: string
  name: string
  firstName?: string
  lastName?: string
  avatarUrl?: string
  role?: string
  twoFactorEnabled?: boolean
}

interface Session {
  id: string
  expiresAt: string
}

interface AuthState {
  user: User | null
  session: Session | null
  isLoading: boolean
  needsTwoFactor: boolean
  setAuth: (user: User, session: Session) => void
  setLoading: (loading: boolean) => void
  setNeedsTwoFactor: (needs: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  session: null,
  isLoading: true,
  needsTwoFactor: false,
  setAuth: (user, session) => set({ user, session, isLoading: false, needsTwoFactor: false }),
  setLoading: (isLoading) => set({ isLoading }),
  setNeedsTwoFactor: (needsTwoFactor) => set({ needsTwoFactor, isLoading: false }),
  clear: () => set({ user: null, session: null, isLoading: false, needsTwoFactor: false }),
}))
